/**
 * The icon picker's light constants (KPR-1188, KPE-037 "icons on demand").
 *
 * The picker's INDEX (names, categories and search keywords: components/iconPickerIndex.js,
 * iconKeywords.js, iconCategories.js) is its own chunk, loaded the first time
 * the picker opens, and must never be pulled into main.js by a static import.
 * What IconColorPicker, Input and the pack loader need before that chunk
 * arrives lives here: no data, no imports.
 */

/** The category filter's "no filter" value. */
export const ALL_ICON_CATEGORIES = '__all__';

/** The category an icon the categories file leaves out is shown under. */
export const OTHER_ICON_CATEGORY = 'Other';

/**
 * A search that scatters its results over several categories asks for a
 * category's whole pack only when at least this many of the page's icons
 * are in it; fewer are fetched as their own small files. (Browsing, with no
 * search, always fetches packs: a page of a category is one request.)
 */
export const PACK_MIN_NAMES = 6;

/** HEART_PULSE -> "Heart Pulse". */
export const iconLabelOf = key => `${key || ''}`.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
